import { Typography, TypographyProps } from '@mui/material';
import React from 'react';

const H1 = ({ children, sx, ...props }: TypographyProps): JSX.Element => (
  <Typography
    variant="h1"
    sx={{
      mb: '48px',
      color: '#212B36',
      fontWeight: 400,
      fontSize: '36px',
      lineHeight: '44px',
      textAlign: 'center',
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export default H1;
